export default __webpack_public_path__ + "static/media/wordPress.4fbbfa22.jpg";